/* global Sentry */
import React, { Component } from 'react';
import ErrorPage from '../components/ErrorPage';
import { Provider } from 'react-redux';
import i18n from '../../src/i18n/translate';

export default class ErrorBoundedProvider extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof window.Sentry !== 'undefined') {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        Sentry.captureException(error);
      });
    }
  }

  render() {
    if (this.state.hasError) {
      //render fallback UI
      const errorMessage = <React.Fragment>
        {i18n.t('Please try to refresh this page. If that doesn\'t work you can go to ')}
        <a href="https://everfihelp.force.com/foundry/s/" target="_blank">{i18n.t('this page')}</a> {i18n.t('for help.')}
      </React.Fragment>;

      return <ErrorPage errors={[ errorMessage ]} title={i18n.t('Something Went Wrong.')}/>;
    }

    //when there's not an error, render children untouched
    return <Provider {...this.props}/>;
  }
}
